/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Thead} from './style';
import {TableHeaderCell} from './table-header-cell';
import {ColumnsType} from './props';

export interface ITableHeader {
  columns: ColumnsType;
  sortHeaderColumn: string | null;
  sortAction: (key: string) => void;
}

export const TableHeader = ({columns, sortHeaderColumn, sortAction}: ITableHeader): JSX.Element => {
  const renderHeader = (): JSX.Element[] => Object.keys(columns).map((key: string, index: number): JSX.Element => (
    <TableHeaderCell
      key={`table-header-cell-${index}`}
      column={columns[key]}
      sortHeaderColumn={sortHeaderColumn}
      sortAction={sortAction}
    />
  ));

  return (
    <Thead>
      <tr>{renderHeader()}</tr>
    </Thead>
  );
};

export default TableHeader;